import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { RequestDutiesRefundCTA } from "./ctas";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var HowDutiesWorkIA = function HowDutiesWorkIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize, articles) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  if (!orderIsFreeDutiesEligible(brandOrder)) {
    return undefined;
  }
  return RequestDutiesRefundCTA(strictLocalize, articles);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var HOW_DUTIES_WORK = function HOW_DUTIES_WORK(strictLocalize) {
  return strictLocalize({
    id: "xfT++X",
    defaultMessage: [{
      "type": 0,
      "value": "Zo werken invoerrechten op Faire"
    }]
  });
};
var DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS = function DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS(strictLocalize) {
  return strictLocalize({
    id: "X6z/E+",
    defaultMessage: [{
      "type": 0,
      "value": "De invoerrechten worden berekend op basis van het soort goederen dat wordt ingevoerd, zoals bepaald door de door het merk verstrekte tariefcodes. Aangezien de invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van de invoerrechten voor je bestelling weergeeft. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw), die je volledig betaalt. Als de werkelijke invoerheffingen hoger uitvallen dan de invoerrechtenpromotie die je hebt ontvangen, kun je het verschil terugvragen in Faire-tegoed."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "nyTq3Z",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling komt in aanmerking voor de promotie met gratis invoerrechten. De invoerrechten worden berekend op basis van het soort goederen dat wordt ingevoerd, zoals bepaald door de door het merk verstrekte tariefcodes. Als invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van invoerrechten voor je bestelling weerspiegelt. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw), die je volledig betaalt. Als de werkelijke kosten van invoerrechten en uitbetalingsvergoeding hoger uitvallen dan de promotie die je hebt ontvangen, kun je het verschil terugvragen in Faire-tegoed wanneer de bestelling is geleverd."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "S1hVGp",
    defaultMessage: [{
      "type": 0,
      "value": "Deze bestelling komt niet in aanmerking voor de promotie met gratis invoerrechten. De invoerrechten worden berekend op basis van het soort goederen dat wordt ingevoerd, zoals bepaald door de door het merk verstrekte tariefcodes. De vervoerder stuurt je een factuur voor alle invoerheffingen (inclusief invoerrechten en btw), die je volledig betaalt. Als invoerrechten voor je bestelling zijn gedekt, passen we bij het afrekenen een korting toe op je factuur die de geschatte kosten van invoerrechten voor je bestelling weerspiegelt. "
    }]
  });
};